import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OpnBoardMembersSaveModel } from '.';

const localApiUrl = `${environment.apiUrl}/RequestOpnBoardMembersList`;

@Injectable()
export class OpnBoardMembersListService {

  constructor(private http: HttpClient) { }

  delete(id: number): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Delete`,id).toPromise();
  }

  save(model: OpnBoardMembersSaveModel): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
